import { TextList, TextListItem } from '@oneaudi/unified-web-components';
import parse from 'html-react-parser';
import type { ReactNode } from 'react';
import React, { cloneElement } from 'react';
import styled from 'styled-components';
import xss from 'xss';
import { SYS_FONT_SIZES_RELATIVE_325 } from '@oneaudi/unified-web-common';
import { renderReactNodeWithFootnotes } from './renderReactNodeWithFootnotes';

const whiteList = {
  b: [],
  i: [],
  u: [],
  ul: [],
  ol: [],
  li: [],
  br: [],
  p: [],
  strong: [],
  a: ['href', 'title', 'target', 'rel'],
};

const StyledList = styled(TextList)`
  margin-block: var(--spacing-relative-md);
  margin-inline-start: var(--spacing-relative-md});
`;

const StyledListItem = styled(TextListItem)`
  font-size: var(${SYS_FONT_SIZES_RELATIVE_325});
  margin-block-end: var(--spacing-relative-sm);
  margin-block-start: 0px;
`;

const createElement = (type: string, props?: object, ...children: ReactNode[]): JSX.Element => {
  if (type === 'br') {
    return React.createElement(type, props);
  }
  const renderChildren = () => renderReactNodeWithFootnotes(children);
  if (type === 'ul') {
    return React.createElement(
      StyledList,
      {
        size: 'md',
        variant: 'bullet',
        margin: [0, 0, 0, 0],
        ...props,
      },
      renderChildren(),
    );
  }
  if (type === 'ol') {
    return React.createElement(
      StyledList,
      {
        size: 'md',
        variant: 'decimal',
        margin: [0, 0, 0, 0],
        ...props,
      },
      renderChildren(),
    );
  }
  if (type === 'li') {
    return React.createElement(StyledListItem, props, renderChildren());
  }
  return React.createElement(type, props, renderChildren());
};

export function convertRichText(htmlString: string) {
  return parse(
    xss(htmlString, {
      whiteList,
      stripIgnoreTag: true,
    }),
    {
      library: {
        cloneElement,
        createElement,
        isValidElement: (element: unknown): boolean => {
          return Boolean(element);
        },
      },
    },
  );
}
